import React, { useState } from "react";
import "./EmiCalculator.css";

const EmiCalculator = () => {
  const [loanAmount, setLoanAmount] = useState("");
  const [tenure, setTenure] = useState("");
  const [interestRate, setInterestRate] = useState(12);
  const [emi, setEmi] = useState(0);

  const calculateEMI = () => {
    const principal = parseFloat(loanAmount);
    const annualInterest = parseFloat(interestRate);
    const months = parseInt(tenure);

    if (!principal || !annualInterest || !months) {
      setEmi(0);
      return;
    }

    const monthlyInterest = annualInterest / (12 * 100);
    const emiAmount =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, months)) /
      (Math.pow(1 + monthlyInterest, months) - 1);

    setEmi(Math.round(emiAmount));
  };

  return (
    <div className="emi-container">
      <h2>Calculate your EMI</h2>
      <p>Input the loan amount, tenure and interest rate</p>

      <input
        type="number"
        placeholder="Loan Amount"
        value={loanAmount}
        onChange={(e) => setLoanAmount(e.target.value)}
      />

      <select value={tenure} onChange={(e) => setTenure(e.target.value)}>
        <option value="">Tenure: Select</option>
        <option value="12">12 months</option>
        <option value="24">24 months</option>
        <option value="36">36 months</option>
        <option value="48">48 months</option>
        <option value="60">60 months</option>
      </select>

      <select
        value={interestRate}
        onChange={(e) => setInterestRate(e.target.value)}
      >
        <option value="10">Interest Rate: 10%</option>
        <option value="11">Interest Rate: 11%</option>
        <option value="12">Interest Rate: 12%</option>
        <option value="13">Interest Rate: 13%</option>
        <option value="14">Interest Rate: 14%</option>
      </select>

      <div className="emi-result">EMI Amount: ₹ {emi}</div>

      <button className="calculate-btn" onClick={calculateEMI}>
        Calculate
      </button>
    </div>
  );
};

export default EmiCalculator;
